import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AllUsers } from '@shared/model/all-user.model';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AllUserService {
  private readonly baseUrl = environment.baseUrl;
private readonly routePrefix = 'api/v1/admin/user';
  constructor(
    private http: HttpClient,
    )
     { }


  getAllUsers(startPage: number,pageSize: number): Observable<AllUsers> {
    return this.http.get(`${this.baseUrl}/${this.routePrefix}/all-users?startPage=${startPage}&pageSize=${pageSize}`)
      .pipe(map((res: any) => res.data));
  }
}
